<template>
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g class="fill-current">
                <path d="M1,10 L4,10 L4,20 L1,20 L1,10 Z M6,0 L9,0 L9,20 L6,20 L6,0 Z M11,8 L14,8 L14,20 L11,20 L11,8 Z M16,4 L19,4 L19,20 L16,20 L16,4 Z" id="Combined-Shape"></path>
            </g>
        </g>
    </svg>
</template>
